import Api from "./Api";
import config from "../config";
import store from "../store";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function isPushSupported() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

async function hasServiceWorkerRegistration() {
  if (!("serviceWorker" in navigator)) return false;
  const registration = await navigator.serviceWorker.getRegistration();
  return !!registration;
}

// Subscribes the current browser to push and saves the subscription on the
// server. Works for guests too — the subscribe endpoint is public.
async function subscribeToPush() {
  if (!isPushSupported()) return false;
  try {
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(config.vapidPublicKey),
      });
    }
    const subJson = subscription.toJSON();
    await Api().post("push/subscribe", {
      endpoint: subJson.endpoint,
      keys: subJson.keys,
      userPhone: store.state.AuthModule?.user?.phone ?? null,
    });
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function unsubscribeFromPush() {
  if (!isPushSupported()) return;
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await Api().post("push/unsubscribe", {
        endpoint: subscription.endpoint,
      });
      await subscription.unsubscribe();
    }
  } catch (err) {
    console.log(err);
  }
}

export default {
  isPushSupported,
  hasServiceWorkerRegistration,
  subscribeToPush,
  unsubscribeFromPush,
};
